import { useExperimentTreatment } from '@ms/yammer-experiments-context';
import { usePreloadComponent } from '@ms/yammer-libs-lazy';
import { LazyRelayModuleWrapper } from '@ms/yammer-relay/dist/environment';
import type { FC } from 'react';
import React, { useEffect } from 'react';

import { enableGlobalCopilot, resetGlobalCopilotHostMount, useHasGlobalCopilotOpened } from '../../store';
import { resetCatalystLifecycle } from '../../store/globalCopilot/catalystSDKStore';

import { LoadableCatalystGlobalCopilotDrawerHost } from './LoadableCatalystGlobalCopilotDrawerHost';
import { LoadableGlobalCopilotDrawer, loadGlobalCopilotDrawer } from './LoadableGlobalCopilotDrawer';

enableGlobalCopilot();

export interface DeferredGlobalCopilotDrawerProps {
  readonly isFeedbackEnabled: boolean;
}

export const DeferredGlobalCopilotDrawer: FC<DeferredGlobalCopilotDrawerProps> = ({ isFeedbackEnabled }) => {
  usePreloadComponent(loadGlobalCopilotDrawer);

  const isCatalystEnabled = useExperimentTreatment('VivaEngageCatalystSDK');
  const hasOpened = useHasGlobalCopilotOpened();

  useEffect(
    () => () => {
      resetGlobalCopilotHostMount();
      resetCatalystLifecycle();
    },
    []
  );

  if (isCatalystEnabled) {
    return <LoadableCatalystGlobalCopilotDrawerHost isFeedbackEnabled={isFeedbackEnabled} />;
  }

  if (!hasOpened) {
    return null;
  }

  return (
    <LazyRelayModuleWrapper>
      <LoadableGlobalCopilotDrawer isFeedbackEnabled={isFeedbackEnabled} />
    </LazyRelayModuleWrapper>
  );
};
